$(function () {
  const slider = $(".mv__slider");
  const list = $(".mv__slider_list");

  let speed = 1; // 数値を小さくすると遅くなる
  let position = 0;

  /*
   * 画像を複製
   * 枚数が不定でも対応
   */
  list.append(list.html());

  const loopWidth = list[0].scrollWidth / 2;

  function mvSlide() {
    position -= speed;

    if (-position >= loopWidth) {
      position += loopWidth;
    }

    list.css("transform", `translate3d(${position}px,0,0)`);

    requestAnimationFrame(mvSlide);
  }

  mvSlide();
});

// MVのラインを合わせる関数
function syncMvLine() {
  const white = document.getElementById("mv_line_white");
  const gray = document.getElementById("mv_line_gray");

  if (!white || !gray) return;

  const rect = white.getBoundingClientRect();

  gray.style.position = "fixed";
  gray.style.left = rect.left + "px";
  gray.style.top = rect.top + "px";
  gray.style.width = rect.width + "px";
  gray.style.height = rect.height + "px";
  gray.style.margin = "0";
  gray.style.transform = "none";
  gray.style.pointerEvents = "none";
}
syncMvLine();
window.addEventListener("load", syncMvLine);
window.addEventListener("resize", syncMvLine);
window.addEventListener("scroll", syncMvLine);

/* =========================================
   second_view controller
========================================= */
document.addEventListener("DOMContentLoaded", () => {
  // 動かす対象（HTML内の目隠しSVGの中にある、上波グループと下波グループ）
  const waveTop = document.getElementById("second_view_mask_top");
  const waveBottom = document.getElementById("second_view_mask_bottom");

  if (!waveTop || !waveBottom) return;

  // スクロール状態の管理
  let scrollY = window.scrollY;
  let lastScrollY = window.scrollY;

  // 波の横スクロール現在位置（px）
  let topX = 0;
  let bottomX = 0;

  // ループさせる基本幅（1枚のSVG波パーツの横幅）
  const baseWaveWidth = 1024;

  // スクロールイベントで現在の位置をリアルタイムに同期
  window.addEventListener(
    "scroll",
    () => {
      scrollY = window.scrollY;
    },
    { passive: true },
  );

  // メインアニメーションループ（毎フレーム実行）
  function tick() {
    requestAnimationFrame(tick);

    // 前のフレームからのスクロール移動量を計算
    const diff = scrollY - lastScrollY;
    lastScrollY = scrollY;

    // スクロール速度に応じた加速倍率（速くスクロールすると最大3倍まで波が加速）
    const speedBoost = 1 + Math.min(Math.abs(diff) * 0.02, 2);

    // 毎フレーム、左（マイナス方向）に波を動かす
    topX -= 1 * speedBoost; // 上波の基本速度
    bottomX -= 0.8 * speedBoost; // 下波の基本速度（上下で速度を変えて自然に）

    // 端（-1024px）まで流れたら、1ミリの狂いもなく0に戻してシームレスに永久ループ
    if (topX <= -baseWaveWidth) topX = 0;
    if (bottomX <= -baseWaveWidth) bottomX = 0;

    // SVG内のグループ要素に対して、厳密に位置を反映
    waveTop.style.transform = `translateX(${topX}px)`;
    waveBottom.style.transform = `translateX(${bottomX}px)`;
  }

  // ループアニメーションを開始
  tick();
});

// リストの高さ揃え
function setEqualHeight() {
  document.querySelectorAll("ul.set_height").forEach((list) => {
    const items = list.querySelectorAll("li");
    if (items.length === 0) return;

    // 一旦リセット
    items.forEach((item) => {
      item.style.minHeight = "";
    });

    // 一番高いliを取得
    let maxHeight = 0;

    items.forEach((item) => {
      maxHeight = Math.max(maxHeight, item.offsetHeight);
    });

    // 全liに適用
    items.forEach((item) => {
      item.style.minHeight = `${maxHeight}px`;
    });
  });
}

window.addEventListener("load", setEqualHeight);
window.addEventListener("resize", setEqualHeight);

$("#fembe__shosai_bt").on("click", function () {
  if ($(this).hasClass("close")) {
    $(this).removeClass("close");
    $(".fembe__hidden").each(function (i, elm) {
      $(elm).addClass(".open");
      $(elm).slideDown(300);
    });
  } else {
    $(this).addClass("close");
    $(".fembe__hidden").each(function (i, elm) {
      $(elm).removeClass(".open");
      $(elm).slideUp(300);
    });
  }
});

$(function () {
  const $slider = $(".teiki__slider");

  if (!$slider.length) return;

  // 要素を複製
  $slider.append($slider.html());

  let position = 0;
  const speed = 0.6; // 数字を大きくすると速くなる

  function teikiSlider() {
    position -= speed;

    if (Math.abs(position) >= $slider[0].scrollWidth / 2) {
      position = 0;
    }

    $slider.css("transform", "translateX(" + position + "px)");

    requestAnimationFrame(teikiSlider);
  }

  teikiSlider();
});

$("#teiki-faq ul li .q__box").on("click", function () {
  var li = $(this).parents("li");
  if (li.hasClass("open")) {
    li.find(".a__box").slideUp(300, function () {
      li.removeClass("open");
    });
  } else {
    li.find(".a__box").slideDown(300, function () {
      li.addClass("open");
    });
  }
});

// // SP MVのSliderの位置調整
$(window).on("load resize", function () {
  setChangePos();
});
$(window).on("resize", function () {
  mvSliderPos();
});

mvSliderPos();

function setChangePos() {
  var posLeft = $("#set__change_wrap").offset().left;
  var slider = $("#set__change_slider .mv__slider");
  slider.css("left", posLeft * -1);
}

function mvSliderPos() {
  var w = $(window).outerWidth();
  var slider = $("#mv__slider_con");
  var sliH = slider.outerHeight();
  var spArea = $("#mv__sp_slider_area");
  if (w > 1000) {
    // pc
    if (spArea.hasClass("active")) {
      setTimeout(function () {
        spArea.removeClass("active");
        slider.removeAttr("style");
      }, 10);
    }
  } else {
    // SP
    if (!spArea.hasClass("active")) {
      spArea.addClass("active");
      setTimeout(function () {
        var areaPos = spArea.position().top;
        slider.css("top", areaPos);
      }, 300);
      spArea.height(sliH);
    }
  }
}
